import { ReactNode, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@store/store";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import { deepEqual, omit } from "@helpers/generals";
import { setDialogConfig, setPopupConfig } from "@store/slices/componentsSlice";
import {
    useLazyGetApplicationResumeByCompanyIdQuery,
    useLazyGetApplicationResumeQuery,
    useLazyGetApplicationsMarketplaceResumeQuery,
} from "@services/api/applications";
import { setApplicationSelected } from "@store/slices/componentsSlice";
import { useLazyGetTaxSystemQuery } from "@services/api/catalogs";
import { UUID } from "crypto";

export default function Solicitud() {
    const params = useParams();
    const navigation = useNavigate();
    const dispatch = useDispatch();

    const applicationSelected = useSelector((state: RootState) => state.components.applicationSelected);
    const sectionSelected = useSelector((state: RootState) => state.components.currentSection.section);
    const companiesUser = useSelector((state: RootState) => state.session.filters.shared_filters.companies);
    const financialSelected = useSelector((state: RootState) => state.session.filters.shared_filters.financials);

    const [triggerGetTaxSystemInfo] = useLazyGetTaxSystemQuery();
    const [triggerGetApplications] = useLazyGetApplicationResumeQuery();
    const [triggerGetApplicationResumeByCompanyId] = useLazyGetApplicationResumeByCompanyIdQuery();
    const [triggerGetAppsMarketplace] = useLazyGetApplicationsMarketplaceResumeQuery();

    const loadApplicationData = async () => {
        try {
            let app_data = undefined;
            // let urlParams = new URLSearchParams();
            // urlParams.append("q", `company_source:equals:'${params.companyName?.toUpperCase()}'`);
            // urlParams.append("q", `id_application_company:equals:'${params.id}'`);

            // companiesUser.forEach((company) => urlParams.append("company", company.id));

            // let data = undefined;
            // if (params.companyName === "pymio") {
            //     financialSelected.forEach((financial) => urlParams.append("financial_inc", financial.id));
            //     data = await triggerGetAppsMarketplace(urlParams.toString()).unwrap();
            // } else {
            //     data = await triggerGetApplications(urlParams.toString()).unwrap();
            // }

            // app_data = data.items.at(0);

            app_data = await triggerGetApplicationResumeByCompanyId({
                companyId: Number(params.id),
                params: new URLSearchParams([
                    ["company_source", params.companyName?.toUpperCase() as string],
                ]).toString(),
            }).unwrap();
            if (app_data == undefined) {
                navigation("/not_found");
                return;
            }

            if (
                deepEqual(
                    omit(applicationSelected, [
                        "total_time_seconds",
                        "screen_time_seconds",
                        "client_total_time_seconds",
                        "total_time_hours",
                        "screen_time_hours",
                        "dictamenCompletado",
                        "company_docs_validated",
                        "shareholder_docs_validated",
                        "owners_docs_validated",
                        "existsSDC",
                        "visit_analysis_validated",
                        "check_control_validated",
                    ]),
                    omit(app_data, [
                        "total_time_seconds",
                        "screen_time_seconds",
                        "client_total_time_seconds",
                        "total_time_hours",
                        "screen_time_hours",
                    ]),
                )
            ) {
                return;
            }

            const taxSystemInfo = await triggerGetTaxSystemInfo(app_data.tax_system.id).unwrap();

            dispatch(
                setApplicationSelected({
                    ...app_data,
                    tax_system: {
                        ...app_data.tax_system,
                        config_extra: omit(taxSystemInfo.config_extra, [
                            "bpm_lateral_options",
                            "bpm_lateral_options_v2",
                        ]),
                    },
                }),
            );
        } catch (error: any) {
            if (error.status == 401) {
                navigation("/");
            }
        }
    };

    useEffect(() => {
        dispatch(setPopupConfig());
        dispatch(setDialogConfig());
    }, [sectionSelected]);

    useEffect(() => {
        // Descomentar cuando se realice la separación de la información en local storage a session storage
        if (
            applicationSelected.id === "0-0-0-0-0" ||
            Number(params.id) !== applicationSelected.id_application_company
        ) {
            loadApplicationData();
        }
    }, [params, applicationSelected]);

    return <Outlet />;
}
